import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { apiFetch, getTheme, viewportWidth, noSelect } from 'helpers'
import { Route } from 'react-router-dom'
import { get, isEqual } from 'lodash'
import svgLoading from 'assets/svg/icon-loading.svg'
import svgLogoFull from 'assets/svg/logo-full.svg'

// Components
import HorizontalCentered from 'components/HorizontalCentered'
import VerticalCentered from 'components/VerticalCentered'
import TabBar from 'components/TabBar'

// Containers
import Authenticate from 'containers/Authenticate'
import Login from 'containers/Login'
import Profile from 'containers/Profile'
import Reviews from 'containers/Reviews'
import Settings from 'containers/Settings'

const blacklist = ['/login', '/authenticate']
const menus = [
  { title: 'โปรไฟล์', key: 'profile' },
  { title: 'รีวิวทั้งหมด', key: 'reviews' },
  // { title: 'Customers', key: 'customer' },
  // { title: 'Notifications', key: 'notifications' },
  { title: 'ตั้งค่า', key: 'settings' }
]

@connect(state => ({
  windowLoaded: get(state, 'app.windowLoaded'),
  messageType: get(state, 'app.messageType'),
  message: get(state, 'app.message'),
  duration: get(state, 'app.duration'),
  me: get(state, 'vendor.me'),
  verifying: get(state, 'vendor.verifyAttempting')
}))
export default class App extends Component {
  constructor (props) {
    super(props)
    this.state = {

    }
  }

  componentWillReceiveProps (nextProps) {
    if (!this.props.windowLoaded && nextProps.windowLoaded) {
      const { dispatch, history } = nextProps
      if (nextProps.location.pathname !== '/authenticate') {
        apiFetch({
          dispatch,
          key: 'VERIFY',
          v4: true,
          url: '/v4/vendors/me'
        })
          .then(result => history.replace(nextProps.location.pathname === '/' ? '/profile' : nextProps.location.pathname))
          .catch(() => history.replace('/login'))
      }
    }
    if (!this.props.message && nextProps.message) {
      setTimeout(() => {
        nextProps.dispatch({ type: 'SEND_MESSAGE', messageType: null, message: '', duration: null })
      }, nextProps.duration || 1500)
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    return !isEqual(this.props.me, nextProps.me) ||
      this.props.message !== nextProps.message ||
      !isEqual(this.props.location, nextProps.location)
  }

  render () {
    const { history, windowLoaded, location, verifying, messageType, message } = this.props
    const isNotBlacklist = blacklist.indexOf(location.pathname) === -1
    if ((!windowLoaded || verifying) && location.pathname !== '/authenticate') {
      return (
        <BgTiffany>
          <HorizontalCentered>
            <VerticalCentered>
              <IconLoading src={svgLoading} />
            </VerticalCentered>
          </HorizontalCentered>
        </BgTiffany>
      )
    }

    return (
      <Container hasTabBar={viewportWidth() < 768 && isNotBlacklist}>
        <Navbar visible={isNotBlacklist}>
          <GridContainer>
            <LogoWrapper>
              <Logo src={svgLogoFull} />
            </LogoWrapper>
            <RightMenus>
              {menus.map(menu =>
                <MenuLink key={menu.key} active={get(location.pathname.split('/'), 1) === menu.key} to={menu.key}
                  onClick={() => history.replace(`/${menu.key}`)}>
                  {menu.title}
                </MenuLink>
              )}
            </RightMenus>
          </GridContainer>
        </Navbar>
        <Body hasPadding={isNotBlacklist}>
          <NavbarSeparator />
          <Route exact path='/login' component={Login} />
          <Route exact path='/authenticate' component={Authenticate} />
          <Route path='/profile' component={Profile} />
          <Route path='/reviews' component={Reviews} />
          <Route path='/settings' component={Settings} />
          <TabBar history={history}
            location={location}
            visible={isNotBlacklist}
            menus={menus}
            activeKey={get(location.pathname.split('/'), 1)} />
          <MessageWrapper visible={message}>
            <Message>
              <MessageIcon messageType={messageType}>{messageType === 'success' ? '✓' : '✗'}</MessageIcon>
              <span>{message}</span>
            </Message>
          </MessageWrapper>
        </Body>
      </Container>
    )
  }
}

const Container = styled.div`
  ${props => props.hasTabBar ? `
    padding-bottom: 50px;
  ` : ''}
`
const Navbar = styled.div`
  background-color: white;
  height: 50px;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 9999;
  border-bottom: 1px solid ${getTheme`colorBorder`};
  display: ${props => props.visible ? 'block' : 'none'};
`
const GridContainer = styled.div`
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;
  background-color: white;
`
const LogoWrapper = styled.div`
  height: 50px;
  line-height: 50px;
  @media(min-width: 768px) {
    display: inline-block;
    vertical-align: top;
    width: 160px;
    padding-left: 10px;
  }
  @media(max-width: 767px) {
    text-align: center;
  }
`
const Logo = styled.img`
  height: 30px;
  margin-top: 10px;
`
const RightMenus = styled.div`
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 170px);
  text-align: right;
  @media(max-width: 767px) { display: none; }
`
const MenuLink = styled.div`
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 100px;
  line-height: 50px;;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: ${getTheme`colorBackground`};
  }
  ${noSelect}
  ${props => props.active && `
    color: ${props.theme.colorTiffany};
    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      left: 0px;
      right: 0px;
      height: 5px;
      background-color: ${props.theme.colorTiffany};
    }
  `}
`

const Body = styled.div`
  background-color: ${getTheme`colorBackground`};
  padding-top: ${props => props.hasPadding ? 51 : 0}px;
`
const NavbarSeparator = styled.div`
  height: 1px;
  background-color: ${getTheme`colorBorder`};
  display: ${props => props.visible ? 'block' : 'none'};
`
const BgTiffany = styled.div`
  background-color: ${getTheme`colorTiffany`};
  min-height: 100vh;
`
const IconLoading = styled.img`
  width: 60px;
  height: 60px;
  vertical-align: top;
  filter: brightness(0) invert(1);
`

const MessageWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 30000;
  text-align: center;
  transition: top 0.3s ease;
  ${props => props.visible ? `
    top: 10px;
  ` : `
    top: -100px;
  `}
`
const Message = styled.div`
  padding: 10px 16px;
  border-radius: 4px;
  -webkit-box-shadow: 0 4px 12px rgba(0,0,0,.15);
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  background: #fff;
  display: inline-block;
  pointer-events: all;
  font-size: 16px;
  line-height: 20px;
`
const MessageIcon = styled.div`
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  color: white;
  text-align: center;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  margin-right: 10px;
  ${props => props.messageType === 'success' ? `
    background-color: ${props.theme.colorGreen};
  ` : props.messageType === 'error' ? `
    background-color: ${props.theme.colorCoral};
  ` : `
    display: none;
  `}
`



// WEBPACK FOOTER //
// ./src/containers/App.js